import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
class CleanButton extends Component {
  render() {
    const {loading, loadingReasons} = this.props;
    return (
      <Button primary
        type='button'
        content='LIMPIAR'
        disabled={loading || loadingReasons}
        onClick={this.props.handleCleanClick}
      />
    );
  }
}
const mapStateToProps = (state) => {
  return {
    'dealer': state.session.dealerId,
    'agency': state.session.dealerAgency,
    'loading': state.dealerSpecialOrders.loading,
    'loadingReasons': state.dealerSpecialOrders.loadingReasons,
    'orders': state.dealerSpecialOrders.list,
  };
};
const {
  addMessageBoxError,
  createDealerSpecialOrder,
} = Actions;
export default connect(mapStateToProps, {
  addMessageBoxError,
  createDealerSpecialOrder,
})(CleanButton);
